import React, { useEffect } from 'react';
import './AnnouncementModal.css';

/**
 * Generic dismissible announcement popup. Message is an array of paragraph
 * strings (rendered as separate <p> tags) so multi-paragraph copy stays
 * readable instead of one wall of text.
 */
const AnnouncementModal = ({ title, message, signature, onClose }) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [onClose]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return (
        <div className="announcement-modal-overlay" onClick={handleOverlayClick}>
            <div className="announcement-modal-content">
                <button className="announcement-modal-close" onClick={onClose} aria-label="Close">×</button>
                {title && <h2 className="announcement-modal-title">{title}</h2>}
                <div className="announcement-modal-body">
                    {message.map((paragraph, i) => (
                        <p key={i}>{paragraph}</p>
                    ))}
                </div>
                {signature && <p className="announcement-modal-signature">{signature}</p>}
                <button className="announcement-modal-button" onClick={onClose}>Got it</button>
            </div>
        </div>
    );
};

export default AnnouncementModal;
